"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iOSPostMessage = exports.androidPostMessage = exports.postMessage = exports.communicationUtilities = void 0;
var resize_observer_1 = require("resize-observer");
var postMessageActions_1 = __importDefault(require("@incentivegames/ig-types/lib/constants/communication/postMessageActions"));
var os_1 = __importDefault(require("@incentivegames/ig-types/lib/constants/os"));
var platforms_1 = require("@incentivegames/ig-types/lib/constants/platforms");
exports.communicationUtilities = {
    /**
     * If the setting allowParentChanges is true, it tries to scroll the parent, if false, it sends a postMessage scrollTo.
     * @param allowParentChanges boolean. A flag to indicate whether or not changes to the parent from the iframe are allowed.
     * @param isDevEnvironment boolean. A flag to indicate whether or not the game is running in a development environment.
     */
    scrollParentToTop: function (allowParentChanges, isDevEnvironment) {
        if (allowParentChanges && !isDevEnvironment) {
            window.parent.scrollTo(0, 0);
        }
        else {
            exports.communicationUtilities.sendPostMessage.scrollTo(0);
        }
    },
    /**
     * Collection of different postMessages available
     */
    sendPostMessage: {
        login: function () {
            exports.postMessage({ action: postMessageActions_1.default.LOGIN, payload: { redirectUrl: "" + window.location.href } });
        },
        logout: function () {
            exports.postMessage({ action: postMessageActions_1.default.LOGOUT });
        },
        getPlayerData: function () {
            exports.postMessage({ action: postMessageActions_1.default.PLAYER_DATA });
        },
        playerData: function (token) {
            exports.postMessage({ action: postMessageActions_1.default.PLAYER_DATA, payload: { token: token } });
        },
        // @deprecated `getToken()` will slowly be replaced by `getPlayerData()`.
        getToken: function () {
            exports.postMessage({ action: postMessageActions_1.default.GET_TOKEN });
        },
        register: function () {
            exports.postMessage({ action: postMessageActions_1.default.REGISTER, payload: { redirectUrl: "" + window.location.href } });
        },
        resize: function (resizeHeight) {
            var _a, _b;
            var scrollHeight = (_b = resizeHeight !== null && resizeHeight !== void 0 ? resizeHeight : (_a = document.getElementById('root')) === null || _a === void 0 ? void 0 : _a.scrollHeight) !== null && _b !== void 0 ? _b : 0;
            if (scrollHeight && scrollHeight > 300) {
                exports.postMessage({ action: postMessageActions_1.default.RESIZE, payload: { scrollHeight: scrollHeight }, scrollHeight: scrollHeight });
            }
        },
        updateBalance: function () {
            exports.postMessage({ action: postMessageActions_1.default.UPDATE_BALANCE });
        },
        scrollTo: function (position) {
            exports.postMessage({ action: postMessageActions_1.default.SCROLLTO, payload: { position: position } });
        },
        getConfig: function (tokenFromParentType, tokenCookieName, currencyFromParentType, languageFromParentType, supportedCurrencies, supportedLanguages, defaultCurrency, defaultLanguage, currencyCodeIdentifier, languageCodeIdentifier) {
            exports.postMessage({
                action: postMessageActions_1.default.GET_CONFIG,
                payload: {
                    config: getConfig(tokenFromParentType, tokenCookieName, currencyFromParentType, languageFromParentType, supportedCurrencies, supportedLanguages, defaultCurrency, defaultLanguage, currencyCodeIdentifier, languageCodeIdentifier)
                }
            });
        },
        /**
         * Sends a message with a payload type:"something". This is use to allow the user to track user´s actions, like clicking a certain button, bet...
         * @param type type of action to track, i.e. clickOnBet, clickStart, revealPlayer
         * @param additionalPayload Optional. Provide additional object properties that will be merged into the message's payload.
         */
        tracking: function (type, additionalPayload) {
            var additionalPayloadFields = additionalPayload || {};
            exports.postMessage({ action: postMessageActions_1.default.TRACKING, payload: __assign({ type: type }, additionalPayloadFields) });
        },
        /**
         * We expect the client to open a popup or redirect the user to a info/how to play page.
         * Some clients will use the redirectUrl we send in the payload, but it is not neccesary in cases like the popup
         * @param howToPlayUrl OPTIONAL. URL to send the user
         */
        howToPlay: function (howToPlayUrl) {
            if (howToPlayUrl) {
                exports.postMessage({ action: postMessageActions_1.default.HOW_TO_PLAY, payload: { howToPlayUrl: howToPlayUrl, redirectUrl: "" + window.location.href } });
            }
            else {
                exports.postMessage({ action: postMessageActions_1.default.HOW_TO_PLAY, payload: { redirectUrl: "" + window.location.href } });
            }
        },
        /**
         * Sends a message to redirect the user to a specific location on the parent's website.
         * @param redirectType The type of redirect we want to perform, e.g. home, sportsbook, etc.
         * @param url Optional. The url to redirect to, this is usually only used if the URL is dynamic, e.g. in jackpots where the url will be different depending on the template
         * @param urlLocation Optional. Where the url should be updated, the current values are window or iframe
         * @param additionalPayload Optional. Provide additional object properties that will be merged into the message's payload.
         */
        redirect: function (redirectType, url, urlLocation, additionalPayload) {
            var additionalPayloadFields = additionalPayload || {};
            exports.postMessage({ action: postMessageActions_1.default.REDIRECT, payload: __assign({ redirectType: redirectType, url: url, urlLocation: urlLocation }, additionalPayloadFields) });
        },
        addToBetslip: function (stake, selections) {
            exports.postMessage({
                action: postMessageActions_1.default.ADD_TO_BETSLIP,
                payload: {
                    stake: stake,
                    selections: selections.map(function (selection) {
                        return { id: selection };
                    })
                }
            });
        },
        /**
         * This function is used when we need to create a bespoke payload from the client site
         * @param payload An object with anything
         */
        addToBetslipWithPayload: function (payload) {
            exports.postMessage({
                action: postMessageActions_1.default.ADD_TO_BETSLIP,
                payload: payload
            });
        },
        /**
         * Sends a message to add selections to the parent site's betslip with more detailed info than the standard addToBetslip call
         * @param stake The stake of the bet to placed on the client site, e.g. 50
         * @param currencyCode The currency code of the stake to be placed, e.g. GBP
         * @param selections The selection information for each selection on the bet to be placed
         */
        addToBetslipDetailed: function (stake, currencyCode, selections) {
            exports.postMessage({
                action: postMessageActions_1.default.ADD_TO_BETSLIP,
                payload: {
                    stake: stake,
                    currencyCode: currencyCode,
                    selections: selections.map(function (selection) {
                        return { id: selection.id, extEventId: selection.extEventId, price: selection.price };
                    })
                }
            });
        },
        shareEntry: function (entry) {
            var payload = {
                entry: entry
            };
            exports.postMessage({ action: postMessageActions_1.default.SHARE, payload: payload });
        },
        share: function (platform, gameType, prize) {
            var payload = {
                platform: platform,
                gameType: gameType
            };
            if (prize) {
                payload.prize = prize;
            }
            exports.postMessage({ action: postMessageActions_1.default.SHARE, payload: payload });
        },
        /**
         * User clicked "Join" on DreamTeam Fives promotion widget
         */
        join: function () {
            exports.postMessage({ action: postMessageActions_1.default.JOIN });
        },
        upsell: function (upsellEntry) {
            exports.postMessage({
                action: postMessageActions_1.default.UPSELL,
                payload: {
                    entry: upsellEntry
                }
            });
        }
    },
    /**
     * Based on the login type tries to log the user in via postMessage or redirect.
     * @param loginType string. The method used to initiate the login on the parent (PostMessage, Redirect).
     * @param loginUrl string. The login part of the URL to redirect to when loginType is set to Redirect.
     */
    login: function (loginType, loginUrl) {
        switch (loginType) {
            case 'PostMessage':
                exports.communicationUtilities.sendPostMessage.login();
                break;
            case 'Redirect':
                var loginLocation = window.top.location.protocol + '//' + window.top.location.host + loginUrl;
                window.top.document.location.href = loginLocation + ("?redir=" + encodeURIComponent(window.location.href) + "&referrer=" + encodeURIComponent(window.top.location.href));
                break;
            default:
                console.warn('Unknown entry type!');
                break;
        }
    },
    /**
     * Based on the registration type tries to register the user via postMessage or redirect.
     * @param registrationType string. The method used to initiate the registration on the parent (PostMessage, Redirect).
     * @param registrationUrl string. The registration part of the URL to redirect to when registrationType is set to Redirect.
     */
    register: function (registrationType, registrationUrl) {
        switch (registrationType) {
            case 'PostMessage':
                exports.communicationUtilities.sendPostMessage.register();
                break;
            case 'Redirect':
                var regLocation = window.top.location.protocol + '//' + window.top.location.host + registrationUrl;
                window.top.document.location.href = regLocation + ("?redir=" + encodeURIComponent(window.location.href) + "&referrer=" + encodeURIComponent(window.top.location.href));
                break;
            default:
                console.warn('Unknown entry type!');
                break;
        }
    },
    /**
     * Add an observer to the app height, when it changes it calls the postMessage resize.
     *
     * Call this function in the App component, before declaring the component (outside of it)
     */
    addHeightObserver: function () {
        var sendHeight;
        var resizeObserver = new resize_observer_1.ResizeObserver(function () {
            clearTimeout(sendHeight);
            sendHeight = setTimeout(function () {
                exports.communicationUtilities.sendPostMessage.resize();
            }, 50);
        });
        var root = document.getElementById('root');
        if (root) {
            resizeObserver.observe(root);
        }
    },
    /**
     * @returns OS, possible values [os.IOS, os.ANDROID, os.WEB]
     * os is an enum avialable in ig-types
     */
    getOs: function () {
        var userAgent = window.navigator.userAgent;
        var platform = window.navigator.platform;
        var iosPlatformList = [platforms_1.iosPlatforms.IPAD, platforms_1.iosPlatforms.IPHONE, platforms_1.iosPlatforms.IPOD];
        if (iosPlatformList.includes(platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
            return os_1.default.IOS;
        }
        else if (/Android/.test(userAgent)) {
            return os_1.default.ANDROID;
        }
        else {
            return os_1.default.WEB;
        }
    }
};
/**
 * Sends a postMessage to the parent.
 *
 * If the app is in an android or IOS device, it will ALSO send a special type of postMessage.
 * @param options PostMessage options data.
 */
exports.postMessage = function (options) {
    switch (exports.communicationUtilities.getOs()) {
        case os_1.default.IOS:
            exports.iOSPostMessage(options);
            break;
        case os_1.default.ANDROID:
            exports.androidPostMessage(options);
            break;
    }
    try {
        if (document.referrer && document.referrer !== '') {
            if (new URL(window.location.href).origin !== new URL(document.referrer).origin) {
                // window.parent.postMessage(options, new URL(window.parent.origin).origin);
                window.parent.postMessage(options, new URL(document.referrer).origin);
            }
        }
    }
    catch (error) {
        console.warn('error: ', error);
    }
};
/**
 * Sends a postMessage to the parent in an android app.
 *
 * It only works if the client injects an object called Android to handle this (like Virgin did).
 *
 * Also, in order to build the app the call has to be done outside the React app (in the index.html inside a script tag)
 * @param options PostMessage options data
 */
exports.androidPostMessage = function (options) {
    if (window.androidPostMessageJS) {
        window.androidPostMessageJS(options);
    }
};
/**
 * Sends a postMessage to the parent in an ios app
 * @param options PostMessage options data
 */
exports.iOSPostMessage = function (options) {
    // (window as any).webkit.nativeCallback.postMessage(options);
    if (window.webkit) {
        try {
            window.webkit.messageHandlers.native.postMessage(options);
        }
        catch (error) {
            console.warn('error: ', error);
        }
    }
};
/**
 * Returns an object with the config values.
 * @param tokenFromParentType string. The method used to pass the token from the parent to the iframe (PostMessage, Url, Cookies)
 * @param tokenCookieName string. The name of the token cookie (only relevant when tokenFromParentType is Cookies)
 * @param currencyFromParentType string. The method used to pass the currency from the parent to the iframe (PostMessage, Url)
 * @param languageFromParentType string. The method used to pass the language from the parent to the iframe (PostMessage, Url)
 * @param supportedCurrencies string[]. The list of supported currencies. If a currency not on this list is passed from the parent, the currency will not be updated in the iframe.
 * @param supportedLanguages string[]. The list of supported languages. If a language not on this list is passed from the parent, the language will not be updated in the iframe.
 * @param defaultCurrency string. The default currency used if no currency is passed into the iframe from the parent.
 * @param defaultLanguage string. The default language used if no language is passed into the iframe from the parent.
 * @param currencyCodeIdentifier string. The identifier used to find the currency code in the URL. This is only relevant when currencyFromParentType is set to URL.
 * @param languageCodeIdentifier string. The identifier used to find the language code in the URL. This is only relevant when languageFromParentType is set to URL.
 * @returns IGetConfig. The populated config object.
 */
var getConfig = function (tokenFromParentType, tokenCookieName, currencyFromParentType, languageFromParentType, supportedCurrencies, supportedLanguages, defaultCurrency, defaultLanguage, currencyCodeIdentifier, languageCodeIdentifier) {
    return {
        tokenFromParentType: tokenFromParentType,
        tokenCookieName: tokenCookieName,
        currencyFromParentType: currencyFromParentType,
        languageFromParentType: languageFromParentType,
        supportedCurrencies: supportedCurrencies,
        supportedLanguages: supportedLanguages,
        defaultCurrency: defaultCurrency,
        defaultLanguage: defaultLanguage,
        currencyCodeIdentifier: currencyCodeIdentifier,
        languageCodeIdentifier: languageCodeIdentifier
    };
};
